import type { CodeType } from './code-type.enum';

export interface Code {
  campaignName: string;
  campaignDescription: string;
  promotionName: string;
  promotionDescription: string;
  startTime: Date;
  endTime: Date;
  type: CodeType;
  code: string;
  state: CodeState;
}

export enum CodeState {
  ACTIVE = 'ACTIVE',
  PROCESSING = 'PROCESSING',
}
